import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { BooleanCons, StringConst } from 'src/app/constants/const';
import { TooltipTextAddPieces, TooltipTextDeletePieces } from 'src/app/constants/texts';
import { PatternService } from 'src/app/services/pattern.service';


@Component({
  selector: 'app-counter-pieces',
  templateUrl: './counter-pieces.component.html',
  styleUrls: ['./counter-pieces.component.scss']
})
export class CounterPiecesComponent implements OnInit {
  @Input() pieceInit: number | undefined;
  @Input() isPackage = false;
  @Output() newpieceEmitter = new EventEmitter<number>();
  @Output() lockItems = new EventEmitter<number>();
  @Input() matStyle = false;
  subscription = new Subscription();
  toolTipTextAdd = StringConst.empty;
  toolTipTextDelete = StringConst.empty;
  constructor(public patternService: PatternService) { }

  ngOnInit(): void {
    const tooltipTextDicAdd: { [key: number]: string } = {
      0: TooltipTextAddPieces.pieces,
      1: TooltipTextAddPieces.packages
    };

    const tooltipTextDicDelete: { [key: number]: string } = {
      0: TooltipTextDeletePieces.pieces,
      1: TooltipTextDeletePieces.packages
    };
    this.toolTipTextAdd = tooltipTextDicAdd[+this.isPackage];
    this.toolTipTextDelete = tooltipTextDicDelete[+this.isPackage];

  }

  decrement(): void {
    if (Number(this.pieceInit) > 1) {
      const piece = Number(this.pieceInit) - 1;
      this.newpieceEmitter.emit(piece);
    }

  }

  inclement(): void {
    if ((this.pieceInit ?? 0) < 999999) {
      const piece = Number(this.pieceInit) + 1;
      this.newpieceEmitter.emit(piece);
    }
  }

  submitPiece(): void {
    const numbers = Number(this.pieceInit);
    if (numbers > 0) {
      this.newpieceEmitter.emit(numbers);
    } else {
      this.lockItems.emit(0);
    }
  }
}

